import { Button as DefaultButton } from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";

type PdfButtonProps = {
	disabled?: boolean;
	disableElevation?: boolean;
	disableFocusRipple?: boolean;
	disableRipple?: boolean;
	size?: string;
	onClick: () => void;
	sx?: object;
	content: string;
	className?: string;
};
export default function PdfButton(props: Readonly<PdfButtonProps>) {
	const {
		disabled = false,
		disableElevation = false,
		disableFocusRipple = false,
		disableRipple = false,
		size = "20",
		sx = {},
		onClick,
		content,
		className = "",
	} = props;

	return (
		<DefaultButton
			disabled={disabled}
			onClick={onClick}
			className={className}
			disableElevation={disableElevation}
			disableFocusRipple={disableFocusRipple}
			disableRipple={disableRipple}
			sx={{
				...sx,
				color: "var(--text-color)",
				textTransform: "none",
				fontFamily: "var(--font-family-v2)",
			}}
			startIcon={
				<InsertPhotoIcon
					sx={{
						"&.MuiSvgIcon-root": {
							fontSize: `${size}px`,
						},
					}}
				/>
			}
		>
			{content}
		</DefaultButton>
	);
}
